import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {useAppSelector} from "../../../../redux/store";
import {Link} from "react-router-dom";
import {Alerts, CPSMessages, PageNames} from "commonUtils/enumerations";
import FormValidationAlert from "components/FormComponents/Alert/FormValidationAlert";
import {logMessage} from "services/loggerService";
import "../../../Dashboard/Dashboard.css";
import {initialMessage, loggedMessage, message} from "commonUtils/utils";
import { SurveyAlertPros } from "features/Dashboard/dashboardType";

const DashboardAlert: React.FC<any> = alertsData => {
  const alertData = alertsData?.alertsData ??[];
  const surveyAlerts =alertsData?.surveyAlerts ??[];
  
  const [showAlert, setShowAlert] = React.useState<boolean>(false);
  const [serverValidation, setServerValidation] =
    React.useState<message>(initialMessage);

  const {userDetails} = useAppSelector(state => {
    return state.auth;
  });

  const handleOpenAlertLink = (event: any) => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} had opened the Alert Link ${event.currentTarget}.`,
        PageNames.DASHBOARD,
      );
    } catch (error: any) {
      loggedMessage(error, serverValidation?.message, PageNames.DASHBOARD);
    }
  };

  const totalAlertCount: number = alertData?.reduce(
    (acc: number, {alertCount}: {alertCount: number}) => acc + alertCount,
    0,
  ) + (surveyAlerts?.length ?? 0);

  return (
    <>
      {showAlert && serverValidation?.message && (
        <FormValidationAlert
          closeIcon={true}
          showAlertBox={showAlert}
          setShowAlertBox={setShowAlert}
          severity={
            (serverValidation?.isSuccessMessage ?? false)
              ? Alerts.SUCCESS
              : (serverValidation?.isValidationMessage ?? false)
                ? Alerts.INFO
                : Alerts.ERROR
          }
          message={serverValidation?.message}
        />
      )}
      {(alertData.length > 0 || surveyAlerts?.length > 0) ? (
        <Paper className="paper-look">
          <Typography component="div" className="alert-heading">
            <NotificationImportantOutlinedIcon className="outline-icon" />
            {"Alerts" +
              " ( " +
              ((alertData?.length > 0 || surveyAlerts?.length > 0)
                ? totalAlertCount
                : "0") +
              " )"}
          </Typography>
          <Box className="my-border" />
          <Box className="box-padding-bottom" />
          <List className="my-list">
            <ListItem key={'start1'} alignItems="flex-start">
              <ListItemText
                key={-1}
                primary={
                  <>
                    <Typography component="p" className="types">
                      Type
                    </Typography>
                  </>
                }
              />
              <Typography component="p" className="numbers">
                Number
              </Typography>
            </ListItem>
          </List>
          <List className="my-list dashboard-alert-block">
            {(alertData?.length > 0 &&
              alertData?.map((row: any, index: number) => (
                <>
                <ListItem
                    key={`alert_${index}`}
                    className="display-flex align-items-center">
                    <ListItemText
                      key={`alert_li_${index}`}
                      primary={
                        <>
                          <Link  key={`alert_lnk_${index}`}
                            onClick={handleOpenAlertLink}
                            to={`/alerts/${row.pageToLoad}`}>
                            <Typography component="p" className="alert-name">
                              {row.alertName}
                            </Typography>
                          </Link>
                        </>
                      }
                      />
                    <Typography key={`alert_nu_${index}`} component="p" className="alert-count">
                      {row.alertCount}
                    </Typography>
                  </ListItem>
                </>
              )))}
             {(surveyAlerts?.length > 0 &&
                surveyAlerts?.map((row: SurveyAlertPros, index: number) => (
                <>
                  <ListItem
                    key={`survey_${index}`}
                    className="display-flex align-items-center">
                    <ListItemText
                      key={`survey_li_${index}`}
                      primary={
                        <>
                          <Link key={`survey_lnk_${index}`}
                            onClick={handleOpenAlertLink}
                            to={`/dashboard/${row.pageToLoad}`}>
                            <Typography component="p" className="alert-name">
                              {row.surveyName}
                            </Typography>
                          </Link>
                          <Typography key={`survey_Tag_${index}`} component="p" className="types">
                              {row.tagLine}
                            </Typography>
                        </>
                      }
                      />
                    <Typography key={`survey_count_${index}`} component="p" className="alert-count">1</Typography>
                  </ListItem>
                </>
              )))}
          </List>
        </Paper>
      ) : (
        <Paper className="paper-look">
          <Typography component="div" className="alert-heading">
            <NotificationImportantOutlinedIcon className="outline-icon" />
            {"Alerts" + " ( " + "0" + " )"}
          </Typography>
          <Box className="my-border" />
          <Box className="box-padding-bottom" />
          <List className="my-list">
            <ListItem className="display-flex align-items-center">
              <ListItemText
                key={-1}
                primary={
                  <>
                    <Typography key={-2} component="p" className="types">
                      Type
                    </Typography>
                  </>
                }
              />
              <Typography key={-3} component="p" className="numbers">
                Number
              </Typography>
            </ListItem>
          </List>
          <List key={-4}  className="recordsnotfound">
            {CPSMessages.DASHBOARDALERTNODATA}
          </List>
        </Paper>
      )}
    </>
  );
};
export default DashboardAlert;
